import {useCallback, useEffect} from "react";
import {getServerTime} from "../store/app/ActionCreators";
import {useAppDispatch} from "../store";
import {updateServerTime} from "../store/app/Slice";

const useServerTime = () => {
    const dispatch = useAppDispatch()

    const handleFetchServerTime = useCallback(() => {
        if (document.visibilityState === 'visible') {
            dispatch(getServerTime())
        }
    }, [dispatch])

    useEffect(() => {
        dispatch(getServerTime())

        const intervalId = setInterval(() => {
            dispatch(updateServerTime())
        }, 1000)

        document.addEventListener('visibilitychange', handleFetchServerTime);
        // window.addEventListener('focus', handleFetchServerTime);

        return () => {
            document.removeEventListener('visibilitychange', handleFetchServerTime);
            // window.removeEventListener('focus', handleFetchServerTime);
            clearInterval(intervalId)
        };
    }, [dispatch, handleFetchServerTime])
}

export default useServerTime